import { SKILL_CATEGORY_IT } from '../components/Adverts/constants'

const skills = (value) =>
  value && Array.isArray(value) ? value.filter(item =>
    item.category === SKILL_CATEGORY_IT &&
    item.name !== ''
  ).length > 0 : false

export default skills



// WEBPACK FOOTER //
// ./src/validators/it-skills.js